<div class="landing-container">
  <div class="header-container">
    <div class="logo">
      <img src="assets/images/BMW-logo.png" class="logo-img"/>
    </div>
  </div>

  <div class="login-container">
    <img src="assets/images/dwp-logout.jpg"  class="login-dwp"/>
    <div class="title">
      {{'' | i18n: 'successfully-logged-out'}}
    </div>
    <div class="form-container">
      <button routerLink="/login"> {{'' | i18n: 'go-to-login'}}</button>
    </div>
  </div>
</div>
